export const CONTACT_URLS = {
  GET_CONTACTS: '/api/coach/contacts/{coachId}/{pageNo}',
  GET_UNINVITED_CONTACTS: '/api/coach/contacts/added/{coachId}',
  SAVE_CONTACT: '/api/coach/contacts/{coachId}',
  DELETE_CONTACT: '/coach/delete-contact/{coachCeoId}',
  INVITE_CONTACT: '/coach/invite/{coachId}/user/{userId}',
  ASSOCIATED_CONTACTS: '/api/coach/contacts/associated/{coachId}',
};
